import { render, staticRenderFns } from "./rubric_settings_tab.vue?vue&type=template&id=ce3fd89c&scoped=true&"
import script from "./rubric_settings_tab.vue?vue&type=script&lang=js&"
export * from "./rubric_settings_tab.vue?vue&type=script&lang=js&"
import style0 from "./rubric_settings_tab.vue?vue&type=style&index=0&id=ce3fd89c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3fd89c",
  null
  
)

export default component.exports